module.exports = __webpack_public_path__ + "img/online-transfer.2b04cfa9.png";